import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { int, bool, string, func, objectOf } from 'prop-types';
import i18next from 'i18next';

import LoadingWrapper from '~app/components/LoadingWrapper';
import { mapSimulationValues } from '~app/screens/CreditSimulation/mappers';
import { isWithoutDownpayment } from '~utils/simulation';
import SimulationActions from '~redux/Simulation/actions';
import Select from '~app/components/Select';

import AdvancePaymentButton from './components/AdvancePaymentButton';
import InstallmentsInfo from './components/InstallmentsInfo';
import styles from './styles.module.scss';
import { getHaveDownpaymentOptions } from './utils';

function FinancedPayment({ currentValue, isConsumer, hasDownpayment, setHasDownpayment }) {
  const dispatch = useDispatch();
  const { downpayment, terms, termsLoading, productType, kind } = useSelector(state => state.simulation);
  const handleSelectHaveDownpayment = value => setHasDownpayment({ ...hasDownpayment, value, error: null });
  useEffect(() => {
    if (kind && productType && currentValue) {
      const values = mapSimulationValues({
        currentValue,
        productType,
        kind,
        isConsumer,
        advancePayment: downpayment
      });
      dispatch(SimulationActions.getTerms(values));
    }
  }, [kind, downpayment]);

  return (
    <>
      {!isWithoutDownpayment(kind) && (
        <AdvancePaymentButton advancePayment={downpayment} isConsumer={isConsumer} />
      )}
      <div className={styles.loadingContainer}>
        <LoadingWrapper withInitialLoading loading={termsLoading}>
          {terms && <InstallmentsInfo />}
          <div className="m-top-4">
            <div className={styles.sectionLabel}>{i18next.t('CreditSimulation:hasDownpaymentLabel')}</div>
            <Select
              name="have_downpayment"
              options={getHaveDownpaymentOptions()}
              placeholder={i18next.t('Common:selectPlaceholder')}
              value={hasDownpayment.value}
              error={hasDownpayment.error}
              onChange={handleSelectHaveDownpayment}
            />
          </div>
        </LoadingWrapper>
      </div>
    </>
  );
}

FinancedPayment.propTypes = {
  currentValue: int,
  hasDownpayment: objectOf(string),
  isConsumer: bool,
  setHasDownpayment: func
};

export default FinancedPayment;
